import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@/components/ui/Dialog'
import { Button } from '@/components/ui/Button'

interface LeaveWorkspaceDialogProps {
  open: boolean
  onClose: () => void
  workspaceName: string
  onConfirm: () => Promise<void>
}

export function LeaveWorkspaceDialog({
  open,
  onClose,
  workspaceName,
  onConfirm,
}: LeaveWorkspaceDialogProps) {
  const { t } = useTranslation()
  const [loading, setLoading] = useState(false)

  async function handleConfirm() {
    setLoading(true)
    try {
      await onConfirm()
    } finally {
      setLoading(false)
    }
  }

  return (
    <Dialog
      open={open}
      title={t('workspace.leaveDialog.title')}
      onClose={onClose}
      footer={
        <>
          <Button variant="ghost" onClick={onClose} disabled={loading}>
            {t('common.cancel')}
          </Button>
          <Button variant="danger" onClick={() => void handleConfirm()} disabled={loading}>
            {loading ? t('common.waiting') : t('workspace.leaveDialog.confirm')}
          </Button>
        </>
      }
    >
      <p
        style={{ margin: 0, color: 'var(--text-muted)', lineHeight: 1.5 }}
        dangerouslySetInnerHTML={{
          __html: t('workspace.leaveDialog.message', { name: workspaceName }),
        }}
      />
    </Dialog>
  )
}
